'use strict';

var DashboardClassTransformerFactory = function DashboardClassTransformerFactory(DataTransformer) {
  function DashboardClassTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'market-dashboard';
    this.targetType = 'dashboard-class-fare';
    this.priority = 0;
  }
  DashboardClassTransformer.prototype = Object.create(DataTransformer.prototype);
  DashboardClassTransformer.constructor = DashboardClassTransformer;
  DashboardClassTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DashboardClassTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + this.targetType + '-' + metrics.join('-');
  };
  DashboardClassTransformer.prototype.transform = function (data, metrics, metricDescriptor) {
    if (data.domain._embedded && data.domain._embedded.marketMonthMetrics) {
      data = data.domain._embedded.marketMonthMetrics;
      var transformed = [];
      var newElement, classIndex, classesLength, currentElement, currentPos, currentClass;
      var dimension = metricDescriptor.dimension.toLocaleUpperCase();
      for (var index = 0, dataLength = data.length; index < dataLength; index++) {
        currentElement = data[index];

        //we have to dimensions : REGULAR and MAPPED
        if (dimension !== currentElement.flowType) {
          continue;
        }
        for (var posIndex = 0, posLength = currentElement.pointOfSales.length; posIndex < posLength; posIndex++) {
          currentPos = currentElement.pointOfSales[posIndex];
          for (classIndex = 0, classesLength = currentPos.classes.length; classIndex < classesLength; classIndex++) {
            currentClass = currentPos.classes[classIndex];
            newElement = {
              'className': currentClass.className,
              'classGroupName': currentClass.classGroupName,
              'market': currentElement.origin + '-' + currentElement.destination,
              'month': currentElement.month - 1,
              'year': currentElement.year,
              'pos': currentPos.posName,
              'currentClassBookings': currentClass.currentMetrics.resHoldTotal,
              'currentClassFare': currentClass.averageFare,
              'lyClassBookings': currentClass.referenceData.currentMetrics.resHoldTotal,
              'lyClassFare': currentClass.referenceData.averageFare,
              'expectedBookings': currentClass.expectedMetrics.resHoldTotal,
              'finalBookingsLY': currentClass.referenceData.finalMetrics.resHoldTotal
            };
            transformed.push(newElement);
          }
        }
      }
      return transformed;
    } else {
      return [];
    }
  };
  return DashboardClassTransformer;
};
DashboardClassTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = DashboardClassTransformerFactory;